export const getFmaState = (
    pathname: string,
    search: string,
    root: string
): string => {
    const queryParams = new URLSearchParams(search);
    queryParams.delete('code');
    queryParams.delete('state');
    let pathName = `${pathname}${
        queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`;
    const isBrandRoot =
        root.startsWith('/ford/') || root.startsWith('/lincoln/');

    if (!pathName.endsWith('/') && !pathName.includes('?')) {
        pathName = pathName + '/';
    }

    const pagePath = isBrandRoot ? pathName : pathName.replace(root, '');

    if (pagePath.split('?')[0].length > 1) {
        return pagePath.startsWith('/') ? pagePath : `/${pagePath}`;
    }

    return '/account-dashboard';
};
